<div class="modal-dialog modal-fullscreen-md-down modal-dialog-centered" role="document" style="max-width:640px;">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Cég adatai</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">
					<div class="col p-0">

						<!-- Tab navigation -->
						<ul class="nav nav-pills m-2">
							<li class="nav-item">
								<button class="nav-link active" data-bs-toggle="tab" data-bs-target="#company-tab-base" type="button">Alapadatok</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#company-tab-invoicing" type="button">Számlázás</button>
							</li>
						</ul>

						<hr class="m-0" />

						<!-- Tab content -->
						<div class="tab-content" id="company-tab-content">

							<!-- Alapadatok tab -->
							<div class="tab-pane p-3 show active" id="company-tab-base" role="tabpanel">

								<%- include('/ui/form', {
									params: [ 'company_base', company ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', fields: [
												{ type: 'hidden', name: 'id' },
												{ type: 'fieldset', title: 'Alapadatok', fields: [
													{
														type: 'text',
														name: 'name',
														title: 'Név'
													},
													{
														type: 'text',
														name: 'tax_number',
														title: 'Adószám'
													},
													{
														type: 'select',
														name: 'group_id',
														title: 'Cégcsoport',
														params: {
															maxItems: 1,
															options: company_groups.data,
															valueField: 'id',
															labelField: 'name',
															searchField: 'name'
														},
														unset_value: null
													},
													{
														type: 'text',
														name: 'uuid',
														title: 'UUID',
														attributes: {
															disabled: true
														}
													}
												]},
												{ type: 'fieldset', title: 'Kapcsolat', fields: [
													{
														type: 'text',
														name: 'phone',
														title: 'Telefon'
													},
													{
														type: 'text',
														name: 'email',
														title: 'E-mail cím'
													}
												]}
											]}
										]}
									]
								}) %>

							</div>

							<!-- Számlázás tab -->
							<div class="tab-pane p-3 show" id="company-tab-invoicing" role="tabpanel">

								<%- include('/ui/form', {
									params: [ 'company_invoicing', company ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', fields: [
												{ type: 'fieldset', title: 'Számlázás', fields: [
													{
														type: 'select',
														name: 'tags',
														title: 'Üzletágak',
														params: {
															maxItems: null,
															options: [ ...Anvil.page.modal.company_tags.data ],
															valueField: 'id',
															labelField: 'name',
															searchField: [ 'name' ],
															render: {
																item: (item, esc) => `<div>${esc(item.name)}</div>`,
																option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
															},
														},
														unset_value: null,
														append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.modal.company.tags = []"><i class="fa fa-fw fa-times"></i></button>'
													},
													{
														type: 'select',
														name: 'distributor_id',
														title: 'Disztribútor',
														help: 'Értékesítő és szolgáltatást nyújtó partner, aki ellátja ezt a céget a termékekkel.',
														params: {
															maxItems: 1,
															options: companies.data.filter(x => x.distributor == 1),
															valueField: 'id',
															labelField: 'name',
															searchField: [ 'tax_number', 'name' ],
															render: {
																item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
																option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
															}
														},
														unset_value: null
													},
													{
														type: 'select',
														name: 'referer_id',
														title: 'Ajánló',
														help: 'A bennünket ide ajánló partner, esetleges jutalék kedvezményezettje.',
														params: {
															maxItems: 1,
															options: companies.data.filter(x => x.referer == 1),
															valueField: 'id',
															labelField: 'name',
															searchField: [ 'tax_number', 'name' ],
															render: {
																item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
																option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
															}
														},
														unset_value: null
													},
													{
														type: 'select',
														name: 'invoicing_period',
														title: 'Számlázási periódus',
														params: {
															maxItems: 1,
															options: [
																{ value: 'monthly', label: 'Havi' },
																{ value: 'quarterly', label: 'Negyedéves' },
																{ value: 'half-yearly', label: 'Féléves' },
																{ value: 'annual', label: 'Éves' }
															],
															valueField: 'value',
															labelField: 'label'
														},
														unset_value: null
													},
													{
														type: 'group',
														title: 'Számlázási cím (székhely)',
														fields: [
															{
																type: 'text',
																name: 'invoice_area_code',
																attributes: {
																	placeholder: 'Irsz.'
																},
																width: 2
															},
															{
																type: 'text',
																name: 'invoice_city',
																attributes: {
																	placeholder: 'Város'
																},
																width: 3
															},
															{
																type: 'text',
																name: 'invoice_address',
																attributes: {
																	placeholder: 'Utca, házszám'
																}
															}
														]
													}
												]}
											]}
										]}
									]
								}) %>

							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer justify-content-between">
			<button type="button" class="btn btn-dark" style="color:tan;" onclick="Anvil.page.modal.issue()"><i class="fa fa-briefcase me-2"></i>Új munkalap</button>
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	issue () {
		Anvil.page.modal.close()
		Anvil.exec('issue/modal_edit', null, {
			link: 'company',
			company_id: Anvil.page.modal.company.id
		})
	},

	async save () {
		const res = await Anvil.exec('company/action_save', Anvil.page.modal.company)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on company
			/*
			let grid = Anvil.models.components.Grid.find('#company_grid')
			grid.select(grid.list.getById(Anvil.page.modal.company.id), true)
			*/

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
